import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import ReactDOM from "react-dom";
import "typeface-roboto";
import LogoBayer from "./assets/logo_bayer.png";
import LogoUM from "./assets/logo_UM.png";
import "./i18n/index";

import { Trans, useTranslation } from "react-i18next";
import FormPasswordReset from "./components/FormPasswordReset/FormPasswordReset";
import {
  RegionLookupService,
  AppleStore,
  LandingPage,
  PlayStore,
  UserRegion,
} from "./helpers/enums";
import redirectToAppropriateHost from "./helpers/redirectToAppropriateHost";
import { getQueryStringValue } from "./helpers/getQueryStringValue";
import { getRegionByLookup } from "./helpers/getRegionByLookup";
import {
  CHANGE_PASSWORD_BAYER_TEXT,
  CHANGE_PASSWORD_DESCRIPTION,
  CHANGE_PASSWORD_TITLE,
  PASSWORD_LABEL,
} from "./i18n/constants";
import "./styles.css";

const theme = createMuiTheme({
  palette: {
    type: "light",
  },
});

const App = () => {
  const { i18n, t } = useTranslation();
  const [displayPage, setDisplayPage] = useState(false);

  const contentId = getQueryStringValue("contentId");
  const eventId = getQueryStringValue("eventId");
  let region = getQueryStringValue("region");

  const changeLanguage = () => {
    if (region === "CONOSUR" || region === "PACA") {
      i18n.changeLanguage("es");
      return;
    } else {
      const { host } = window.location;

      if (
        host.includes(UserRegion.CONOSUR.toLowerCase()) ||
        host.includes(UserRegion.PACA.toLowerCase()) ||
        host.includes(UserRegion.MEXICO.toLowerCase())
      ) {
        i18n.changeLanguage("es");
        return;
      }
    }
    i18n.changeLanguage("pt_BR");
  };

  const redirectOnDeeplink = async () => {
    if (contentId || eventId) {
      let lookupId = contentId;
      let lookupService = RegionLookupService.BY_CONTENT;

      if (eventId) {
        lookupId = eventId;
        lookupService = RegionLookupService.BY_EVENT;
      }

      if (!region) {
        region = await getRegionByLookup(lookupId, lookupService);
      }

      redirectToStoreOrLandingPage(region);
    } else {
      const changeKey = getQueryStringValue("pwrt");
      const apiKey = getQueryStringValue("apiKey");

      if (changeKey && apiKey) {
        // show page components because it's not a deep link
        setDisplayPage(true);
      } else {
        redirectToStoreOrLandingPage(region);
      }
    }
  };

  const redirectToStoreOrLandingPage = (region) => {
    if (isIOS) {
      redirectToAppropriateHost(region, AppleStore);
    } else if (isAndroid) {
      redirectToAppropriateHost(region, PlayStore);
    } else {
      // no alternatives from now, redirecting to Brazil only
      redirectToAppropriateHost(region, LandingPage);
    }
  };

  useEffect(() => {
    async function asyncCalls() {
      await redirectOnDeeplink();
    }

    changeLanguage();
    asyncCalls();
  }, []);

  return displayPage ? (
    <div className="App">
      <div>
        <img src={LogoUM} alt="Logo Universo Médico" />
      </div>
      <h1>
        <Trans i18nKey={CHANGE_PASSWORD_TITLE}>Alterar senha!</Trans>
      </h1>
      <p>
        <Trans i18nKey={CHANGE_PASSWORD_DESCRIPTION}>
          Para alterar sua senha, preencha os campos abaixo:
        </Trans>
      </p>
      <FormPasswordReset
        region={region}
        passwordLabel={t(PASSWORD_LABEL)}
        t={t}
      />
      <div className="duvida-container">
        <img className="logo-bayer" src={LogoBayer} alt="Logo Bayer" />
        <p className="duvida">
          <Trans i18nKey={CHANGE_PASSWORD_BAYER_TEXT}>
            Em caso de dúvida ou problemas na plataforma, por favor, entre em
            contato conosco pelo 0800 7021 241 ou pelo e-mail sac@bayer.com
          </Trans>
        </p>
      </div>
    </div>
  ) : null;
};

const rootElement = document.getElementById("root");
ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <CssBaseline>
      <App />
    </CssBaseline>
  </MuiThemeProvider>,
  rootElement
);



// WEBPACK FOOTER //
// ./src/index.js